module.exports = __webpack_public_path__ + "static/media/card-1.91cb65fd.svg";